import React, { useState, useEffect } from "react";
import { fetchEvents, addEvent, deleteEvent } from "./api";
import checkAuth from "./AuthCheck";
import { useNavigate } from 'react-router-dom';

const AdminEvents = () => {
  const navigate = useNavigate();
  const isLoggedIn = checkAuth();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login'); 
    }
  }, [isLoggedIn, navigate]);

  const [showModal, setShowModal] = useState(false);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    name: "",
    category: "",
    start: "",
    end: "",
  });

  useEffect(() => {
    loadEvents();
  }, []);

  const loadEvents = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await fetchEvents();
      setEvents(data);
    } catch (e) {
      setError("Failed to load events");
    }
    setLoading(false);
  };

  const toggleModal = () => setShowModal(!showModal);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await addEvent({
        name: form.name,
        category: form.category,
        start: form.start,
        end: form.end,
      });
      setForm({ name: "", category: "", start: "", end: "" });
      setShowModal(false);
      loadEvents();
    } catch (e) {
      setError("Failed to add event");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this event?")) return;
    try {
      await deleteEvent(id);
      loadEvents();
    } catch (e) {
      setError("Failed to delete event");
    }
  };

  return (
    <>
      <div className="horizontal gap-10 align-center" style={{ marginBottom: "20px" }}>
        <h1>Events</h1>
        <button className="btn-primary-primary" onClick={toggleModal}>
          Add New Event
        </button>
      </div>

      {error && <div style={{ color: 'red' }}>{error}</div>}
      {loading ? (
        <div>Loading events...</div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Event Name</th>
              <th>Category</th>
              <th>Start Date / Time</th>
              <th>End Date / Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {events.length === 0 ? (
              <tr><td colSpan="5">No events found.</td></tr>
            ) : (
              events.map(ev => (
                <tr key={ev.id}>
                  <td>{ev.name}</td>
                  <td>{ev.category}</td>
                  <td>{ev.start}</td>
                  <td>{ev.end}</td>
                  <td>
                    <button className="btn-secondary" onClick={() => handleDelete(ev.id)}>Delete</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>Add New Event</h2>
            <form onSubmit={handleAdd}>
              <input name="name" type="text" placeholder="Event Name" className="input" value={form.name} onChange={handleChange} required />
              <input name="category" type="text" placeholder="Category" className="input" value={form.category} onChange={handleChange} required />
              <input name="start" type="datetime-local" className="input" value={form.start} onChange={handleChange} required />
              <input name="end" type="datetime-local" className="input" value={form.end} onChange={handleChange} required />
              <div style={{ marginTop: "10px" }}>
                <button className="btn-primary-primary" type="submit">Save</button>
                <button className="btn-secondary" onClick={toggleModal} style={{ marginLeft: "10px" }} type="button">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Optional: Add styles for modal */}
      <style jsx="true">{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .modal-content {
          background: white;
          padding: 20px;
          border-radius: 10px;
          width: 100%;
          max-height: 80vh;
          overflow: auto;
          max-width: 500px;
          box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
        }

        .input {
          width: 100%;
          margin: 5px 0;
          padding: 8px;
          border-radius: 5px;
          border: 1px solid #ccc;
        }

        .btn-primary-primary {
          background-color: #007bff;
          color: white;
          border: none;
          padding: 8px 12px;
          border-radius: 5px;
          cursor: pointer;
        }

        .btn-secondary {
          background-color: #6c757d;
          color: white;
          border: none;
          padding: 8px 12px;
          border-radius: 5px;
          cursor: pointer;
        }
      `}</style>
    </>
  );
};

export default AdminEvents;
